import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'expirationMonth'
})
export class ExpirationMonthPipe implements PipeTransform {

  transform(value: string): any {
    if(value.toString().length === 1) value = '0' + value;
    return value;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/pipes/expiration-month.pipe.ts